import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CakeItEasyWebUiModule } from '@cakeiteasy/web-ui';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';

import { PaymentModule } from '../payment/payment.module';
import { MyAccountComponent } from './components/my-account/my-account.component';
import { OrdersHistoryComponent } from './components/orders-history/orders-history.component';
import { DeliveryAddressComponent } from './components/delivery-address/delivery-address.component';
import { BillingInfoComponent } from './components/billing-info/billing-info.component';
import { CakeRemindersComponent } from './components/cake-reminders/cake-reminders.component';
import { CakeReminderComponent } from './components/cake-reminder/cake-reminder.component';

import { UpsertCalendarModalComponent } from './modals/upsert-calendar-modal/upsert-calendar-modal.component';
import { DeliveryAddressModalComponent } from './modals/delivery-address-modal/delivery-address-modal.component';
import { ImportRemindersModalComponent } from './modals/import-reminders-modal/import-reminders-modal.component';
import { NgBusyModule } from 'ng-busy';
import { ResetPasswordFormComponent } from './components/reset-password-form/reset-password-form.component';

const COMPONENTS = [
  MyAccountComponent,
  OrdersHistoryComponent,
  DeliveryAddressComponent,
  BillingInfoComponent,
  CakeRemindersComponent,
  CakeReminderComponent,

  UpsertCalendarModalComponent,
  DeliveryAddressModalComponent,
  ImportRemindersModalComponent,
];

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    CakeItEasyWebUiModule,
    NgCakeItEasyUtilsModule,
    PaymentModule,
    TranslateModule,
    NgBusyModule,
  ],
  declarations: [
    ...COMPONENTS,
    ResetPasswordFormComponent,
  ],
  exports: [
    ...COMPONENTS,
  ]
})
export class UsersProfileModule {
}
